import { Autocomplete, TextField, Typography } from "@mui/material";
import BaseFormDialog from "../../components/dialogs/BaseFormDialog";
import { useDispatch, useSelector } from "../../redux/hooks";
import { selectSites } from "../../redux/slices/account";
import { SiteData } from "../../types/account";
import { DialogCloseHandler } from "../../types/dialog";
import { CRF_EXPORT_STATUSES_UI, CrfExportFilterUI } from "../../types/crf";
import { exportCrfReport } from "../../redux/slices/crf";

type RequestData = {
  site: SiteData | null,
  status: CrfExportFilterUI | null,
}

const DialogExportReport = ({
  open,
  onClose,
}: {
  open: boolean,
  onClose?: DialogCloseHandler,
}) => {
  const dispatch = useDispatch();
  const sites = useSelector(selectSites);

  const handleSubmit = ({ site, status }: RequestData) => {
    dispatch(exportCrfReport({ site: site || undefined, status: status || undefined }))
    .then(() => {
      onClose && onClose({}, 'closeClick');
    })
    .catch(() => {})
  }

  return (
    <BaseFormDialog
      title='Export CRF data as a CSV file'
      open={open}
      onClose={onClose}
      initialValues={{ site: null, status: null } as RequestData}
      onSubmit={handleSubmit}
    >
      {({
        values,
        setFieldValue,
        handleBlur,
      }) => (
        <>
          <Typography variant='caption' sx={theme => ({ color: theme.palette.secondary.main, mb: 2 })}>
            Note: it may take some time to generate the report depending on how many results match the filters below. The generated CSV file will be emailed to you when it is ready.
          </Typography>

          <Autocomplete
            disablePortal
            options={sites}
            getOptionLabel={site => site.name}
            isOptionEqualToValue={(option: any, value) => value.id === option.id}
            value={values.site}
            onChange={(e, val) => { setFieldValue('site', val) }}
            onBlur={handleBlur}
            sx={{ mb: 2 }}
            renderInput={params => <TextField
              {...params}
              name='site'
              label='Site'
            />}
          />

          <Autocomplete
            disablePortal
            options={CRF_EXPORT_STATUSES_UI}
            value={values.status || null}
            onChange={(_, val) => { setFieldValue('status', val); }}
            renderInput={params => <TextField {...params} label='Status'/>}
          />
        </>
      )}
    </BaseFormDialog>
  );
}

export default DialogExportReport;